import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import EnquiryTable from './EnquiryTable';

const Enquiry = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle='Enquiries' parent='Enquiries' />
      <Container fluid={true}>
        <Row>
          <EnquiryTable />
        </Row>
      </Container>
    </Fragment>
  );
};

export default Enquiry;
